import { render, staticRenderFns } from "./HomeGoods.vue?vue&type=template&id=25d40e7e"
import script from "./HomeGoods.vue?vue&type=script&lang=js"
export * from "./HomeGoods.vue?vue&type=script&lang=js"
import style0 from "./HomeGoods.vue?vue&type=style&index=0&id=25d40e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports